export const values = [
  {
    title: `Value-adding <br class="mobile-hide"/>mindset `,
    bgImg:
      "https://d36rc1r950nl44.cloudfront.net/test/18d4a409-0f1b-479b-bad9-c100958b83c1/events/banner-upload/14i86y70rnm46mea34.webp",
  },
  {
    title: `Problem <br class="mobile-hide"/>solving`,
    bgImg:
      "https://d36rc1r950nl44.cloudfront.net/test/18d4a409-0f1b-479b-bad9-c100958b83c1/events/banner-upload/14i86y70rnm46mea34.webp",
  },
  {
    title: `Speed`,
    bgImg:
      "https://d36rc1r950nl44.cloudfront.net/test/18d4a409-0f1b-479b-bad9-c100958b83c1/events/banner-upload/14i86y70rnm46mi5wn.webp",
  },
  {
    title: `Learning <br class="mobile-hide"/>Agility`,
    bgImg:
      "https://d36rc1r950nl44.cloudfront.net/test/18d4a409-0f1b-479b-bad9-c100958b83c1/events/banner-upload/14i86y70rnm46mjde7.webp",
  },
  {
    title: `Ambition<br class="mobile-hide"/> & courage`,
    bgImg:
      "https://d36rc1r950nl44.cloudfront.net/test/18d4a409-0f1b-479b-bad9-c100958b83c1/events/banner-upload/14i86y70rnm46mkog9.webp",
  },
  {
    title: `Consistency<br class="mobile-hide"/> & reliability`,
    bgImg:
      "https://d36rc1r950nl44.cloudfront.net/test/18d4a409-0f1b-479b-bad9-c100958b83c1/events/banner-upload/14i86y70rnm46mm11e.webp",
  },
  {
    title: `Candour <br class="mobile-hide"/> with care`,
    bgImg:
      "https://d36rc1r950nl44.cloudfront.net/test/18d4a409-0f1b-479b-bad9-c100958b83c1/events/banner-upload/14i86y70rnm46mnb8b.webp",
  },
  // {
  //   title: `Frugality`,
  //   bgImg:
  //     "https://d36rc1r950nl44.cloudfront.net/test/18d4a409-0f1b-479b-bad9-c100958b83c1/events/banner-upload/14i86y70rnm46mpad4.webp",
  // },
  {
    title: `Practical<br class="mobile-hide"/> Optimism`,
    bgImg:
      "https://d36rc1r950nl44.cloudfront.net/test/18d4a409-0f1b-479b-bad9-c100958b83c1/events/banner-upload/14i86y70rnm46mpad4.webp",
  },
];
